import { Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { toolbarStyles as styles } from "./toolbar.stylex";

type StoreEditorNoticesProps = Readonly<{
  conflict: boolean;
  mutating: boolean;
  loading: boolean;
  failure: Readonly<{ message: string }> | null;
  validationErrors: readonly Readonly<{ field: string; message: string }>[];
  announcement: "published" | "pending_review" | null;
  onKeepChanges(): void;
  onDiscardChanges(): void;
  onRetry(): void;
}>;

export function StoreEditorNotices({
  conflict,
  mutating,
  loading,
  failure,
  validationErrors,
  announcement,
  onKeepChanges,
  onDiscardChanges,
  onRetry,
}: StoreEditorNoticesProps) {
  return (
    <>
      {conflict && (
        <div role="alert" {...stylex.props(styles.notice, styles.conflict)}>
          <span>Someone else edited this page while you were editing.</span>
          <Button size="sm" disabled={mutating} onClick={onKeepChanges}>
            Keep my changes
          </Button>
          <Button size="sm" disabled={mutating} onClick={onDiscardChanges}>
            Discard mine, load theirs
          </Button>
        </div>
      )}
      {failure && (
        <div role="alert" {...stylex.props(styles.notice)}>
          <span>{failure.message}</span>
          <Button size="sm" disabled={loading || mutating} onClick={onRetry}>
            Retry
          </Button>
        </div>
      )}
      {validationErrors.length > 0 && (
        <div {...stylex.props(styles.notice)}>
          <ul {...stylex.props(styles.list)}>
            {validationErrors.map((error) => (
              <li key={`${error.field}:${error.message}`}>
                {error.field}: {error.message}
              </li>
            ))}
          </ul>
        </div>
      )}
      {announcement && (
        <div aria-live="polite" {...stylex.props(styles.notice)}>
          {announcement === "published"
            ? "Published — live now."
            : "Pending review — sent to Softmax for the coworld's first-ever approval."}
        </div>
      )}
    </>
  );
}
